import * as React from "react";
import { useEffect } from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { AliasSection, Section, SnapshotSection, UploadSection } from "../Registration/SummarySection";
import "./SummaryForm.scss";

export const SummaryForm = (): JSX.Element => {
    const {
        summaryData,
        setSummaryData,
        getSummaryJson,
        attachments,
        snapshot,
        setOverlay,
        drawnFeatures,
        willAttachDrawing
    } = useRegistrationContext();

    useEffect(() => {
        setOverlay({ isLoading: true });
        setData();
    }, []);

    useEffect(() => {
        setData();
    }, [attachments]);

    const setData = async () => {
        const data = await getSummaryJson();
        setSummaryData(data);
        setOverlay(null);
    };

    return summaryData ? (
        <div className="summary-form">
            <div className="summary-info">
                <Section classname={"info-section"} data={summaryData.customer}></Section>
                <AliasSection classname="info-section" data={summaryData.event}></AliasSection>
                <AliasSection classname="info-section" data={summaryData.place}></AliasSection>
            </div>
            <div className="summary-info">
                {drawnFeatures && drawnFeatures.length ? (
                    <SnapshotSection classname="snapshots-block" snapshot={snapshot}></SnapshotSection>
                ) : null}
                <UploadSection
                    classname="info-section upload-section"
                    title="Iespēja pievienot pielikumus"
                ></UploadSection>
                {willAttachDrawing && (!attachments || !attachments.length) ? (
                    <div className="upload-warning">
                        <div>Nepieciešams pievienot maršruta datus</div>
                        <div>GPX, KML vai citā datu formātā!</div>
                    </div>
                ) : null}
            </div>
        </div>
    ) : null;
};
